import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth/auth-context";
import { useTermsAcceptance } from "../lib/terms/use-terms-acceptance";
import { SplashScreen } from "./SplashScreen";
import { TermsGate } from "./TermsGate";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { status, client, user } = useAuth();
  // Toujours appelé (règle des hooks) : sans effet tant que `status` n'est pas
  // "authenticated" (user = null → le hook reste "checking", jamais consulté).
  const { status: termsStatus, markAccepted } = useTermsAcceptance(client, user);

  if (status === "loading") {
    return <SplashScreen />;
  }

  if (status === "unauthenticated") {
    return <Navigate to="/sign-in" replace />;
  }

  // Gate de consentement (item A) : tant que TERMS_VERSION n'est pas acceptée,
  // on bloque l'accès aux enfants. Lecture en échec → fail-open (cf.
  // useTermsAcceptance) ; seul l'INSERT (dans TermsGate) doit réussir pour franchir.
  if (termsStatus === "checking") {
    return <SplashScreen />;
  }

  if (termsStatus === "required") {
    return <TermsGate onAccepted={markAccepted} />;
  }

  return <>{children}</>;
}
